import { useLocation } from 'wouter';
import {
  Plug,
  Users,
  DollarSign,
  LayoutList,
  KeyRound,
  UserCircle,
  ChevronRight,
} from 'lucide-react';
import { useGetUsers } from '@edison/api-client-react';

export function SettingsPage() {
  const [, navigate] = useLocation();
  const { data: usersData } = useGetUsers();

  const users = usersData?.data?.items ?? [];
  const memberCount = users.length;
  const adminCount = (users as Array<{ role?: string }>)
    .filter(u => u.role === 'tenant_admin').length;

  const cards = [
    {
      icon: Plug,
      title: 'Integrations',
      description: 'GitHub webhooks, devices, MCP capture',
      href: '/integrations',
    },
    {
      icon: Users,
      title: 'Users & roles',
      description: memberCount > 0
        ? `${memberCount} member${memberCount !== 1 ? 's' : ''} · ${adminCount} admin`
        : 'Manage team members and permissions',
      href: '/users',
    },
    {
      icon: DollarSign,
      title: 'Rate cards',
      description: 'Hourly rates per user & project',
      href: '/users?tab=rate-card',
    },
    {
      icon: LayoutList,
      title: 'Audit log',
      description: 'Immutable hash-chained record',
      href: '/audit',
    },
    {
      icon: KeyRound,
      title: 'Access tokens',
      description: 'Scoped auditor / advisor portal access',
      href: '/access-tokens',
    },
    {
      icon: UserCircle,
      title: 'Profile',
      description: 'Your competence record & account',
      href: '/profile',
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>
        <p className="text-sm text-muted-foreground mt-0.5">
          Administer the workspace. Tucked away — you rarely need it.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {cards.map(card => (
          <button
            key={card.title}
            onClick={() => navigate(card.href)}
            className="flex items-center gap-4 p-4 rounded-2xl border border-hairline bg-card text-left hover:bg-surface-3 transition-colors group"
          >
            <div
              className="h-10 w-10 rounded-xl flex items-center justify-center shrink-0"
              style={{ background: 'oklch(0.94 0.006 250)' }}
            >
              <card.icon className="h-5 w-5 text-dim" aria-hidden="true" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[13px] font-semibold text-ink">{card.title}</p>
              <p className="text-[12px] text-dim mt-0.5 truncate">{card.description}</p>
            </div>
            <ChevronRight className="h-4 w-4 text-dim shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
          </button>
        ))}
      </div>
    </div>
  );
}
